import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import {ServiceBase} from '../shared/servicebase'
import { Helper } from '../shared/Helper';
import {Pedido} from '../model/Pedido';

@Injectable({
  providedIn: 'root'
})
export class PedidoService extends ServiceBase{

  constructor(http: HttpClient) { 
    super(http);

  }
  

  Gravar(pedido): Observable<any>{        
    return this.SetValue('pedido',pedido);
  }

  Filtrar(codTabela: string ,filtro:string): Observable<any>{        
    return this.GetValue<any>('pedido/filtrar/'+ codTabela  + '/' + filtro);
  }

  Historico(): Observable<any>{        
    return this.GetValue<any>('pedido/historico/' + Helper.getUserIdToken());
  }

  HistoricoCliente(id): Observable<any>{        
    return this.GetValue<any>('pedido/historico/' + id);
  }

  HistoricoClientePaginated(id, page: number = 0, pageSize: number = 10): Observable<any> {        
    return this.GetValue<any>(`pedido/historico/${id}/${page}/${pageSize}`);
}

  

}
